import React from 'react';

import Header from '../containers/Header.jsx';
import Navigator from '../containers/Navigator.jsx';
import Footer from '../containers/Footer.jsx';
import Form from '../components/Form.jsx';

import '../styles/RichiestaContatti.scss';

function RichiestaContatti(props){
    return(
        <>
            <Header setLanguage={props.setLanguage} {...props.header} />
            <Navigator {...props.navigator} />
            <div id={props.id} className={props.className}>
                <Form {...props.form} />
            </div>
            <Footer {...props.footer} />
        </>
    );
}

export default RichiestaContatti;